import { Box, Typography, Grid2 } from "@mui/material";
import Colors from "../assets/color";
import BlockInfo from "../components/BlockInfo";

const usersDescription = [
  {
    title: "Drivers",
    description: "Find and reserve chargers that work on time, every time. Spend less time searching and more time driving. Save up to $1200 per year compared to public charging and plan every trip with confidence.",
    action: "Join our network",
    img: "platform_for_all_1.jpg",
    url: "/drivers"
  },
  {
    title: "Property Owners",
    description: "Transform your charger into a revenue-generating asset. Manage energy use, track earnings, and power your community’s shift to sustainable mobility. Earn up to $1,800+ per month by hosting and help build sustainable communities.",
    action: "Become a host",
    img: "platform_for_all_2.png",
    url: "/hosts"
  },
  {
    title: "Communities",
    description: "Together, we’re decentralizing EV infrastructure reducing carbon emissions, increasing access, and powering cleaner, connected neighborhoods.",
    action: "Partner with us",
    img: "platform_for_all_3.png",
    url: "mailto:charge@splitev.co"
  },
]

const Section3 = () => {

  return (
    <Box
      id="use-case"
      sx={{
        p: { xs: '64px 20px', sm: '64px 40px', md: '112px 64px' },
        backgroundColor: '#0e0e0e',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          color: Colors.white,
          fontFamily: 'mulish',
          fontSize: { xs: '36px', sm: '42px', md: '48px' },
          fontWeight: 800,
          lineHeight: { xs: '3.5rem', sm: '4rem', md: '5rem' },
        }}
      >
        A platform for everyone.
      </Typography>

      <Grid2 container spacing={{ xs: 8, md: 0 }}
        component="ul"
        sx={{
          listStyle: 'none',
          maxWidth: "140rem",
          margin: { xs: "6rem auto", sm: "8rem auto" },
        }}
      >
        {usersDescription.map((user) =>
          <Box
            component="li"
            sx={{
              width: { xs: '100%', md: 'inherit' },
              display: 'flex',
              justifyContent: 'center',
              ":last-child > hr": { display: 'none' },
              "> hr": { display: { xs: 'none', md: 'flex' } }
            }}
            key={user.title}
          >
            <Box sx={{}}>
              <BlockInfo
                title={user.title}
                description={user.description}
                img={user.img}
                action={user.action}
                url={user.url}
              >
              </BlockInfo>
            </Box>

            <Box component="hr" sx={{ mx: '4rem' }} />
          </Box>
        )}
      </Grid2>
    </Box >
  );
};

export default Section3;
